/* istanbul ignore file */
import React from 'react'
// @ts-ignore no types
import _ from 'lodash'
import { Maybe, OpenHouse } from '@adc/sdk/types'
import {
  Grid,
  InfoPill,
  Text,
  Button,
  constants,
  CardContainer,
  Icon,
  hooks,
} from '@adc/ui-adc'
import classnames from 'classnames/bind'
// @ts-ignore no types
import { formatPhoneNumber } from 'common/utils/formatters'
import moment from 'moment'
import cls from './styles.scss'
const cx = classnames.bind(cls)

export interface TermsCardPropsType {
  elmId: string
  openContactModal: () => void
  openHouseInfo: Maybe<Maybe<OpenHouse>[]> | undefined
  brokerAgent: any
  canRequestPrivateTour: boolean
}

const TermsCard = ({
  elmId,
  openContactModal,
  openHouseInfo,
  brokerAgent,
  canRequestPrivateTour,
}: TermsCardPropsType) => {
  const hasPrivateAgent = Boolean(brokerAgent?.agentEmail)
  const hasOpenHouses = Boolean(openHouseInfo?.length)
  const isMobile = hooks.useIsMobileHook()

  const placeholderDate = '2025-01-01 '

  const openHouseList = (
    <>
      {openHouseInfo?.map((openHouse, index) => {
        const startTime = moment(
          placeholderDate + openHouse?.start_time
        ).format('hh:mm A')
        const endTime = moment(placeholderDate + openHouse?.end_time).format(
          'hh:mm A'
        )
        const date = moment(openHouse?.local_date).format('dddd, MM/DD/YYYY')
        return (
          <Grid.Row
            key={index}
            className={cx({
              'show-divider': index !== 0 || hasPrivateAgent,
            })}
          >
            <Grid.Column computer={16} mobile={16}>
              <div
                className={cx('open-house-container')}
                data-elm-id={`${elmId}-open-house`}
              >
                <div style={{ width: '100%' }}>
                  <Text weight='black' color={constants.ColorNames.Gray}>
                    Open House
                  </Text>
                  <Text weight='medium' elmId={`${elmId}-open-house-date`}>
                    {date}
                  </Text>
                  <Text weight='medium' elmId={`${elmId}-open-house-time`}>
                    {startTime}-{endTime}
                  </Text>
                </div>
                {!isMobile && (
                  <Icon
                    name='house'
                    color={constants.ColorNames.Purple}
                    iconStyle='solid'
                    fitted
                    style={{ fontSize: 36 }}
                    className={cx('open-house-icon')}
                  />
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
        )
      })}
    </>
  )

  return (
    <Grid.Row>
      <Grid.Column>
        <CardContainer
          // @ts-ignore type exists
          padding={!isMobile ? 'large' : 'small'}
          borderColor={constants.ColorNames.Gray}
          dropShadow='small'
          borderRadius='extra-small'
        >
          <div style={{ padding: !isMobile ? '4px 20px 0' : 0 }}>
            <Grid relaxed>
              {(hasPrivateAgent || canRequestPrivateTour) && (
                <Grid.Row>
                  {hasPrivateAgent && (
                    <Grid.Column
                      computer={canRequestPrivateTour ? 8 : 16}
                      mobile={16}
                    >
                      <div
                        className={cx('agent-card', {
                          'private-tour-spacing': canRequestPrivateTour,
                        })}
                      >
                        {/* 
                          // TODO: Leaving this here for now, since we may want to add it later
                          <div className={cx('agent-image')}>
                            <Image
                              src='https://react.semantic-ui.com/images/wireframe/square-image.png'
                              circular
                              fluid
                            />
                          </div> */}
                        <div className={cx('agent-info')}>
                          <Text size='tiny' style={{ paddingLeft: 8 }}>
                            Listing Agent -{' '}
                            <b data-elm-id={`${elmId}-agent-name`}>
                              {brokerAgent.agentName}
                            </b>
                          </Text>
                          <div>
                            <InfoPill
                              size='medium'
                              backgroundColor={constants.ColorNames.White}
                              foregroundColor={constants.ColorNames.Gray}
                              includeBorder={false}
                              elmId={`${elmId}-agent-phone`}
                              icon={
                                <Icon
                                  name='phone'
                                  color={constants.ColorNames.Info}
                                  iconStyle='light'
                                  fitted
                                />
                              }
                              iconColor={constants.ColorNames.Info}
                              label={formatPhoneNumber(brokerAgent.agentPhone)}
                            />
                          </div>
                          <div>
                            <InfoPill
                              size='small'
                              backgroundColor={constants.ColorNames.White}
                              foregroundColor={constants.ColorNames.Gray}
                              includeBorder={false}
                              elmId={`${elmId}-agent-email`}
                              icon={
                                <Icon
                                  name='envelope'
                                  color={constants.ColorNames.Info}
                                  iconStyle='light'
                                  fitted
                                />
                              }
                              iconColor={constants.ColorNames.Info}
                              label={
                                <a href={`mailto:${brokerAgent.agentEmail}`}>
                                  {brokerAgent.agentEmail}
                                </a>
                              }
                            />
                          </div>
                          {brokerAgent.listingAgency && (
                            <div>
                              <InfoPill
                                size='medium'
                                backgroundColor={constants.ColorNames.White}
                                foregroundColor={constants.ColorNames.Gray}
                                includeBorder={false}
                                elmId={`${elmId}-agent-agency`}
                                icon={
                                  <Icon
                                    name='building'
                                    color={constants.ColorNames.Info}
                                    iconStyle='light'
                                    fitted
                                  />
                                }
                                iconColor={constants.ColorNames.Info}
                                label={brokerAgent.listingAgency}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </Grid.Column>
                  )}
                  {canRequestPrivateTour && (
                    <Grid.Column
                      computer={hasPrivateAgent ? 8 : 16}
                      mobile={16}
                    >
                      <div className={cx('private-tour-button-container')}>
                        <Button
                          isStretch
                          role='secondary'
                          color={constants.ColorNames.Info}
                          size='large'
                          onClick={openContactModal}
                          elmId={`${elmId}-private-tour-button`}
                        >
                          Request a Private Tour
                        </Button>
                      </div>
                    </Grid.Column>
                  )}
                </Grid.Row>
              )}
              {hasOpenHouses && openHouseList}
            </Grid>
          </div>
        </CardContainer>
      </Grid.Column>
    </Grid.Row>
  )
}

export default TermsCard
